import React from 'react';
import { NodeProps } from '@xyflow/react';
import GenericStepNode from './GenericStepNode';
import TableInputNode from './TableInputNode';
import TableOutputNode from './TableOutputNode';
import FilterRowsNode from './FilterRowsNode';
import { NodeData } from '../../store/store';
import { createContextLogger } from '../../utils/logger';

const logger = createContextLogger('NodeWrapper');

// Type definitions
interface CustomNodeProps extends Omit<NodeProps, 'data'> {
  data: NodeData;
  type: string;
}

type NodeComponent = React.ComponentType<CustomNodeProps>;

// A mapping of specific node types to their custom components
const customNodeComponents: Record<string, NodeComponent> = {
  TableInput: TableInputNode as NodeComponent,
  tableOutput: TableOutputNode as NodeComponent,
  filterRows: FilterRowsNode as NodeComponent,
};

/**
 * A wrapper component that renders either a custom node component
 * or falls back to GenericStepNode for any undefined type
 */
const NodeWrapper: React.FC<CustomNodeProps> = (props) => {
  const { type } = props;

  // Check if there's a custom component for this type
  const CustomComponent = customNodeComponents[type];

  if (CustomComponent) {
    return <CustomComponent {...props} />;
  }

  // Fall back to GenericStepNode for any undefined type
  return <GenericStepNode {...props} />;
};

export default NodeWrapper;
